const EditIcon = ({ size = 24, isActive = false, className = "", ...props }) => {
  const fillColor = isActive ? "#68D7FF" : "#9EA5B3";

  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 25 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
      {...props}
    >
      <path 
        d="M3.5 17.46V20.5C3.5 20.78 3.72 21 4 21H7.04C7.17 21 7.3 20.95 7.39 20.85L18.31 9.94L14.56 6.19L3.65 17.1C3.55 17.2 3.5 17.32 3.5 17.46ZM21.21 5.63L18.87 3.29C18.7775 3.1973 18.6676 3.12375 18.5466 3.07357C18.4257 3.02339 18.296 2.99756 18.165 2.99756C18.034 2.99756 17.9043 3.02339 17.7834 3.07357C17.6624 3.12375 17.5525 3.1973 17.46 3.29L15.63 5.12L19.38 8.87L21.21 7.04C21.3027 6.94749 21.3762 6.8376 21.4264 6.71663C21.4766 6.59565 21.5024 6.46597 21.5024 6.335C21.5024 6.20403 21.4766 6.07435 21.4264 5.95338C21.3762 5.83241 21.3027 5.72252 21.21 5.63Z" 
        fill={fillColor}
      />
    </svg>
  );
};

export default EditIcon; 